export default __webpack_public_path__ + "static/media/demo1.185d49cd.gif";